export var gbCounties = [{
    'name': 'ABERDEENSHIRE',
    'abbreviation': 'ABRDN'
}, {
    'name': 'ANGUS',
    'abbreviation': 'ANGUS'
}, {
    'name': 'ARGYLL',
    'abbreviation': 'ARGYL'
}, {
    'name': 'AVON',
    'abbreviation': 'AVON'
}, {
    'name': 'AYRSHIRE',
    'abbreviation': 'AYR'
}, {
    'name': 'BANFFSHIRE',
    'abbreviation': 'BANFF'
}, {
    'name': 'BEDFORDSHIRE',
    'abbreviation': 'BDFRD'
}, {
    'name': 'BERKSHIRE',
    'abbreviation': 'BERKS'
}, {
    'name': 'BERWICKSHIRE',
    'abbreviation': 'BRWCK'
}, {
    'name': 'BUCKINGHAMSHIRE',
    'abbreviation': 'BCKHM'
}, {
    'name': 'CAITHNESS',
    'abbreviation': 'CTHNS'
}, {
    'name': 'CAMBRIDGESHIRE',
    'abbreviation': 'CMBRG'
}, {
    'name': 'CHANNEL ISLES',
    'abbreviation': 'CHNLS'
}, {
    'name': 'CHESHIRE',
    'abbreviation': 'CHESH'
}, {
    'name': 'CLACKMANNANSHIRE',
    'abbreviation': 'CLKMN'
}, {
    'name': 'CLEVELAND',
    'abbreviation': 'CLVND'
}, {
    'name': 'CLWYD',
    'abbreviation': 'CLWYD'
}, {
    'name': 'CORNWALL',
    'abbreviation': 'CRNWL'
}, {
    'name': 'COUNTY ANTRIM',
    'abbreviation': 'ANTRM'
}, {
    'name': 'COUNTY ARMAGH',
    'abbreviation': 'ARMGH'
}, {
    'name': 'COUNTY DOWN',
    'abbreviation': 'DOWN'
}, {
    'name': 'COUNTY DURHAM',
    'abbreviation': 'DURHM'
}, {
    'name': 'COUNTY FERMANAGH',
    'abbreviation': 'FRMNG'
}, {
    'name': 'COUNTY LONDONDERRY',
    'abbreviation': 'LNDRY'
}, {
    'name': 'COUNTY TYRONE',
    'abbreviation': 'TYRON'
}, {
    'name': 'CUMBRIA',
    'abbreviation': 'CMBRA'
}, {
    'name': 'DERBYSHIRE',
    'abbreviation': 'DERBY'
}, {
    'name': 'DEVON',
    'abbreviation': 'DEVON'
}, {
    'name': 'DORSET',
    'abbreviation': 'DORST'
}, {
    'name': 'DUMFRIESSHIRE',
    'abbreviation': 'DMFRS'
}, {
    'name': 'DUNBARTONSHIRE',
    'abbreviation': 'DNBRT'
}, {
    'name': 'DYFED',
    'abbreviation': 'DYFED'
}, {
    'name': 'EAST LOTHIAN',
    'abbreviation': 'ELOTH'
}, {
    'name': 'EAST SUSSEX',
    'abbreviation': 'ESUSX'
}, {
    'name': 'ENGLAND',
    'abbreviation': 'ENG'
}, {
    'name': 'ESSEX',
    'abbreviation': 'ESSEX'
}, {
    'name': 'FIFE',
    'abbreviation': 'FIFE'
}, {
    'name': 'FLINTSHIRE',
    'abbreviation': 'FLNT'
}, {
    'name': 'GLOUCESTERSHIRE',
    'abbreviation': 'GLOCS'
}, {
    'name': 'GWENT',
    'abbreviation': 'GWENT'
}, {
    'name': 'GWYNEDD',
    'abbreviation': 'GWYND'
}, {
    'name': 'HAMPSHIRE',
    'abbreviation': 'HAMPS'
}, {
    'name': 'HEREFORDSHIRE',
    'abbreviation': 'HRFRD'
}, {
    'name': 'HERTFORDSHIRE',
    'abbreviation': 'HRTFD'
}, {
    'name': 'INVERNESS-SHIRE',
    'abbreviation': 'INVRN'
}, {
    'name': 'ISLE OF ARRAN',
    'abbreviation': 'ARRAN'
}, {
    'name': 'ISLE OF BARRA',
    'abbreviation': 'BARRA'
}, {
    'name': 'ISLE OF BENBECULA',
    'abbreviation': 'BNBCL'
}, {
    'name': 'ISLE OF BUTE',
    'abbreviation': 'BUTE'
}, {
    'name': 'ISLE OF CANNA',
    'abbreviation': 'CANNA'
}, {
    'name': 'ISLE OF COLL',
    'abbreviation': 'COLL'
}, {
    'name': 'ISLE OF COLONSAY',
    'abbreviation': 'CLNSY'
}, {
    'name': 'ISLE OF CUMBRAE',
    'abbreviation': 'CMBRE'
}, {
    'name': 'ISLE OF EIGG',
    'abbreviation': 'EIGG'
}, {
    'name': 'ISLE OF GIGHA',
    'abbreviation': 'GIGHA'
}, {
    'name': 'ISLE OF HARRIS',
    'abbreviation': 'HARIS'
}, {
    'name': 'ISLE OF IONA',
    'abbreviation': 'IONA'
}, {
    'name': 'ISLE OF ISLAY',
    'abbreviation': 'ISLAY'
}, {
    'name': 'ISLE OF JURA',
    'abbreviation': 'JURA'
}, {
    'name': 'ISLE OF LEWIS',
    'abbreviation': 'LEWIS'
}, {
    'name': 'ISLE OF MAN',
    'abbreviation': 'MAN'
}, {
    'name': 'ISLE OF MULL',
    'abbreviation': 'MULL'
}, {
    'name': 'ISLE OF NORTH UIST',
    'abbreviation': 'NUIST'
}, {
    'name': 'ISLE OF RHUM',
    'abbreviation': 'RHUM'
}, {
    'name': 'ISLE OF SCALPAY',
    'abbreviation': 'SCLPY'
}, {
    'name': 'ISLE OF SKYE',
    'abbreviation': 'SKYE'
}, {
    'name': 'ISLE OF SOUTH UIST',
    'abbreviation': 'SUIST'
}, {
    'name': 'ISLE OF TIREE',
    'abbreviation': 'TIREE'
}, {
    'name': 'ISLE OF WIGHT',
    'abbreviation': 'WIGHT'
}, {
    'name': 'ISLES OF SCILLY',
    'abbreviation': 'SCILY'
}, {
    'name': 'KENT',
    'abbreviation': 'KENT'
}, {
    'name': 'KINCARDINESHIRE',
    'abbreviation': 'KNCRD'
}, {
    'name': 'KINROSS-SHIRE',
    'abbreviation': 'KINRS'
}, {
    'name': 'KIRKCUDBRIGHTSHIRE',
    'abbreviation': 'KRKCB'
}, {
    'name': 'LANARKSHIRE',
    'abbreviation': 'LANRK'
}, {
    'name': 'LANCASHIRE',
    'abbreviation': 'LANCS'
}, {
    'name': 'LEICESTERSHIRE',
    'abbreviation': 'LESTR'
}, {
    'name': 'LINCOLNSHIRE',
    'abbreviation': 'LINCN'
}, {
    'name': 'LONDON',
    'abbreviation': 'LON'
}, {
    'name': 'MERSEYSIDE',
    'abbreviation': 'MRSYD'
}, {
    'name': 'MID GLAMORGAN',
    'abbreviation': 'MGMRG'
}, {
    'name': 'MIDDLESEX',
    'abbreviation': 'MDLSX'
}, {
    'name': 'MIDLOTHIAN',
    'abbreviation': 'MLOTH'
}, {
    'name': 'MORAYSHIRE',
    'abbreviation': 'MORAY'
}, {
    'name': 'NAIRNSHIRE',
    'abbreviation': 'NAIRN'
}, {
    'name': 'NORFOLK',
    'abbreviation': 'NRFLK'
}, {
    'name': 'NORTH HUMBERSIDE',
    'abbreviation': 'NHMBR'
}, {
    'name': 'NORTH YORKSHIRE',
    'abbreviation': 'NYORK'
}, {
    'name': 'NORTHAMPTONSHIRE',
    'abbreviation': 'NHAMP'
}, {
    'name': 'NORTHERN IRELAND',
    'abbreviation': 'NIR'
}, {
    'name': 'NORTHUMBERLAND',
    'abbreviation': 'NUMBL'
}, {
    'name': 'NOTTINGHAMSHIRE',
    'abbreviation': 'NOTHM'
}, {
    'name': 'ORKNEY',
    'abbreviation': 'ORKNY'
}, {
    'name': 'OXFORDSHIRE',
    'abbreviation': 'OXFRD'
}, {
    'name': 'PEEBLESSHIRE',
    'abbreviation': 'PEBLS'
}, {
    'name': 'PERTHSHIRE',
    'abbreviation': 'PERTH'
}, {
    'name': 'POWYS',
    'abbreviation': 'POWYS'
}, {
    'name': 'RENFREWSHIRE',
    'abbreviation': 'RNFRW'
}, {
    'name': 'ROSS-SHIRE',
    'abbreviation': 'ROSS'
}, {
    'name': 'ROXBURGHSHIRE',
    'abbreviation': 'RXBRG'
}, {
    'name': 'SCOTLAND',
    'abbreviation': 'SCT'
}, {
    'name': 'SELKIRKSHIRE',
    'abbreviation': 'SLKRK'
}, {
    'name': 'SHETLAND ISLANDS',
    'abbreviation': 'SHETL'
}, {
    'name': 'SHROPSHIRE',
    'abbreviation': 'SHROP'
}, {
    'name': 'SOMERSET',
    'abbreviation': 'SMRST'
}, {
    'name': 'SOUTH GLAMORGAN',
    'abbreviation': 'SGMRG'
}, {
    'name': 'SOUTH HUMBERSIDE',
    'abbreviation': 'SHMBR'
}, {
    'name': 'SOUTH YORKSHIRE',
    'abbreviation': 'SYORK'
}, {
    'name': 'STAFFORDSHIRE',
    'abbreviation': 'STFRD'
}, {
    'name': 'STIRLINGSHIRE',
    'abbreviation': 'STRLG'
}, {
    'name': 'SUFFOLK',
    'abbreviation': 'SUFLK'
}, {
    'name': 'SURREY',
    'abbreviation': 'SURRY'
}, {
    'name': 'SUTHERLAND',
    'abbreviation': 'STHLN'
}, {
    'name': 'TYNE AND WEAR',
    'abbreviation': 'TYNE'
}, {
    'name': 'VALE OF GLAMORGAN',
    'abbreviation': 'VGL'
}, {
    'name': 'WALES',
    'abbreviation': 'WAL'
}, {
    'name': 'WARWICKSHIRE',
    'abbreviation': 'WRWCK'
}, {
    'name': 'WEST GLAMORGAN',
    'abbreviation': 'WGLMG'
}, {
    'name': 'WEST LOTHIAN',
    'abbreviation': 'WLOTH'
}, {
    'name': 'WEST MIDLANDS',
    'abbreviation': 'WMIDL'
}, {
    'name': 'WEST SUSSEX',
    'abbreviation': 'WSUSX'
}, {
    'name': 'WEST YORKSHIRE',
    'abbreviation': 'WYORK'
}, {
    'name': 'WIGTOWNSHIRE',
    'abbreviation': 'WIGTN'
}, {
    'name': 'WILTSHIRE',
    'abbreviation': 'WILTS'
}, {
    'name': 'WORCESTERSHIRE',
    'abbreviation': 'WRCST'
}];

export default gbCounties;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/data/gb.counties.js
// module id = 261
// module chunks = 0